'use client';

import { Typography, TypographyProps } from '@mui/material';
import { keyframes } from '@emotion/react';

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

interface AnimatedGradientTextProps extends TypographyProps {
  children: React.ReactNode;
}

export default function AnimatedGradientText({ children, ...props }: AnimatedGradientTextProps) {
  return (
    <Typography
      {...props}
      sx={{
        background: 'linear-gradient(45deg, #6b8ce3, #ffffff, #6b8ce3)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundSize: '200% 200%',
        animation: `${gradientAnimation} 6s ease-in-out infinite`,
        ...(props.sx || {}),
      }}
    >
      {children}
    </Typography>
  );
}
